var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable:cyclomatic-complexity */
import { observable, observe, action, computed } from "mobx";
import { UIMessageModel, StakeButtonsStatusesModel, FreeBetModel } from "../../../models";
import { UIMessageStatus, BetStatus, ButtonModifiers, MessageModifiers, StakeButtonsModifiers } from "../../../enums";
import { createTransformer } from "mobx-utils";
export class YourbetMiniBetSlipData {
    constructor(provider, dict) {
        this.isShown = false;
        this.messages = createTransformer((purchaseId) => {
            let allMessages = [];
            let tax = this.getTax(purchaseId);
            if (this.shouldDisplayError()) {
                allMessages = allMessages.concat(this.formatedErrors());
            }
            else if (this.selectionsCount === 1) {
                allMessages.push(this.formatedInfoMessage(this.dict.AddTwoSelectionsToBet, purchaseId));
            }
            const currentPurchase = this.purchases.find(x => x.id === purchaseId);
            const freeBetsMessage = (currentPurchase && currentPurchase.freeBetMessage) || this.dict.BetsAccepted;
            this.betStatus === BetStatus.NewOffer && allMessages.push(this.formatedStakeChangeMessage(purchaseId));
            this.betStatus === BetStatus.Accepted && allMessages.push(this.formatedAcceptedMessage(freeBetsMessage, purchaseId));
            if (currentPurchase && currentPurchase.shouldAcceptNewOdds) {
                allMessages.push(this.formatedOddsChangeMessage(purchaseId));
            }
            if (this.shouldAddTax(tax)) {
                allMessages.push(this.formatedTaxMessage(tax));
            }
            if (this.isBetWaitingOrAccepted) {
                allMessages = allMessages.concat(this.getPurchaseMessages(purchaseId));
            }
            return allMessages;
        });
        this.provider = provider;
        this.errors = this.provider.errors;
        this.selections = this.provider.selections;
        this.purchases = this.provider.purchases;
        this.bets = this.provider.bets;
        this.freeBets = this.provider.freeBets;
        this.dict = dict;
        this.disposeErrors = () => { };
        this.disposePurchases = () => { };
        this.disposeSelections = () => { };
        this.disposeFreeBets = () => { };
        this.disposeBetStatus = () => { };
        this.disposeStakeButtonsStatus = () => { };
        this.disposePlaceBetButtonState = () => { };
        this.disposeBets = () => { };
        this.isPlaceBetButtonDisabled = true;
        this.isChecked = false;
        this.betStatus = this.provider.betStatus;
        this.stakeButtonsStatus = new StakeButtonsStatusesModel({ minusEnabled: false, plusEnabled: true });
    }
    activate() {
        this.disposeErrors = observe(this.provider, "errors", x => {
            this.updateErrors(x.newValue);
            x.newValue.length > 0 && (this.isChecked = false);
        });
        this.disposePurchases = observe(this.provider, "purchases", x => {
            this.updatePurchases(x.newValue);
        });
        this.disposeSelections = observe(this.provider, "selections", x => {
            this.updateSelections(x.newValue);
        });
        this.disposeFreeBets = observe(this.provider, "freeBets", x => {
            this.updateFreeBets(x.newValue);
        });
        this.disposeBetStatus = observe(this.provider, "betStatus", x => {
            this.updateBetStatus(x.newValue);
        });
        this.disposeStakeButtonsStatus = observe(this.provider, "stakeButtonsStatus", x => {
            this.updateStakeButtonsStatus(x.newValue);
        });
        this.disposePlaceBetButtonState = observe(this.provider, "isPlaceBetButtonEnabled", x => {
            this.setIsBetButtonDisabled(!x.newValue);
        });
        this.disposeBets = observe(this.provider, "bets", x => {
            this.updateBets(x.newValue);
        });
        this.provider.activate();
    }
    deactivate() {
        this.provider.deactivate();
        this.betStatus = BetStatus.Default;
        this.disposeBetStatus();
        this.disposeErrors();
        this.disposePurchases();
        this.disposeSelections();
        this.disposeFreeBets();
        this.disposeStakeButtonsStatus();
        this.disposePlaceBetButtonState();
        this.disposeBets();
    }
    //Testing purposes - delete after finish
    get isWaiting() {
        return this.betStatus === BetStatus.Waiting;
    }
    //Testing purposes - delete after finish
    get isAccepted() {
        return this.betStatus === BetStatus.Accepted;
    }
    changeStake(stake, buttonAction) {
        return this.provider.changeStake(stake, buttonAction);
    }
    updateSelections(updatedSelections) {
        this.selections = updatedSelections;
        this.isChecked = false;
    }
    updateFreeBets(updatedFreeBets) {
        this.freeBets = updatedFreeBets;
        updatedFreeBets.length > 0 && this.updateSelectedFreeBetId();
    }
    setIsBetButtonDisabled(value) {
        this.isPlaceBetButtonDisabled = value;
        return this.isPlaceBetButtonDisabled;
    }
    updateErrors(updatedErrors) {
        this.errors = updatedErrors;
    }
    updatePurchases(updatedPurchases) {
        this.purchases = updatedPurchases;
    }
    updateBets(updatedBets) {
        this.bets = updatedBets;
    }
    updateStakeButtonsStatus(updatedStatus) {
        this.stakeButtonsStatus = updatedStatus;
    }
    updateSelectedFreeBetId() {
        if (this.isChecked && this.freeBets.some(fb => fb === this.selectFreeBet)) {
            return this.selectFreeBet;
        }
        return this.selectFreeBet = this.freeBets[0];
    }
    updateNewOfferStatus(waitingBetId, isAccepted) {
        this.provider.updateNewOfferStatus(waitingBetId, isAccepted);
    }
    updateOddsChangeStatus(isAccepted) {
        this.provider.updateOddsChangeStatus(isAccepted);
    }
    getBtnRejected() {
        return {
            label: this.dict.Clear,
            handler: this.clearPurchases,
            modifier: ButtonModifiers.clear,
            dataUatButton: "button-bet-slip-clear-bets",
            dataUatInner: "bet-slip-clear-bets",
            disabled: false
        };
    }
    getBtnAccepted() {
        return {
            label: this.dict.Clear,
            handler: this.clearPurchases,
            modifier: ButtonModifiers.clear,
            dataUatButton: "button-bet-slip-clear-bets",
            dataUatInner: "bet-slip-clear-bets",
            disabled: false
        };
    }
    getBtnNewOffer() {
        let stake = this.purchases.length && this.purchases[0] && this.purchases[0].stake;
        let betId = this.bets.length && this.bets[0] && this.bets[0].id || "0";
        return {
            label: stake,
            handler: this.updateNewOfferStatus.bind(this, betId, false),
            modifier: ButtonModifiers.changedStake,
            disabled: true
        };
    }
    get leftComponentStake() {
        let stake = this.getStake;
        let res = {
            handler: this.changeStake.bind(this),
            buttons: {
                left: {
                    modifier: StakeButtonsModifiers.Minus,
                    handler: this.changeStake.bind(this, stake, StakeButtonsModifiers.Minus),
                    disabled: !this.stakeButtonsStatus.minusEnabled
                },
                right: {
                    modifier: StakeButtonsModifiers.Plus,
                    handler: this.changeStake.bind(this, stake, StakeButtonsModifiers.Plus),
                    disabled: !this.stakeButtonsStatus.plusEnabled
                },
                dataUatButton: "btn-stake",
                dataUatInner: "bet-slip-stake-inner"
            }
        };
        return res;
    }
    get leftComponentButton() {
        let betStatusKey = BetStatus[this.betStatus];
        let res;
        (typeof this[`getBtn${betStatusKey}`] === "function") ?
            res = this[`getBtn${betStatusKey}`]() :
            res = "";
        return res;
    }
    get rightComponent() {
        let purchase = this.purchases.length && this.purchases[0];
        let bet = this.bets.length && this.bets[0];
        if (this.betStatus === BetStatus.Accepted || this.betStatus === BetStatus.Rejected) {
            return {
                label: this.dict.RetainSelections,
                handler: this.retainPurchases,
                modifier: ButtonModifiers.place,
                disabled: false,
                dataUatButton: "place-bet-button",
                dataUatInner: "bet-slip-retain-selections"
            };
        }
        else if (this.betStatus === BetStatus.NewOffer && bet) {
            return {
                label: this.dict.AcceptStake,
                handler: this.updateNewOfferStatus.bind(this, bet.id, true),
                modifier: ButtonModifiers.accepted,
                disabled: false,
                dataUatButton: "button-bet-slip-accepted-stake",
                dataUatInner: "bet-slip-accepted-stake-inner"
            };
        }
        else if (purchase && purchase.shouldAcceptNewOdds) {
            return {
                label: this.dict.AcceptOdds,
                handler: this.updateOddsChangeStatus.bind(this, true),
                modifier: ButtonModifiers.accepted,
                disabled: false,
                dataUatButton: "button-bet-slip-accepted-odds",
                dataUatInner: "bet-slip-accepted-odds-inner"
            };
        }
        else {
            let placeButtonLabel = this.isPlaceBetButtonDisabled && this.selections.findIndex(s => s.suspended === true) !== -1
                ? this.dict.Danger
                : this.dict.PlaceBets;
            return {
                label: placeButtonLabel,
                handler: this.placeBet.bind(this),
                modifier: this.isPlaceBetButtonDisabled ? ButtonModifiers.disabled : ButtonModifiers.place,
                disabled: this.isPlaceBetButtonDisabled,
                dataUatButton: this.isPlaceBetButtonDisabled ? "button-bet-slip-disabled" : "place-bet-button",
                dataUatInner: this.isPlaceBetButtonDisabled ? "bet-slip-disabled-inner" : "bet-slip-place-inner",
            };
        }
    }
    updateBetStatus(updatedBetStatus) {
        this.betStatus = updatedBetStatus;
    }
    updateBetStatusToRejected() {
        this.updateBetStatus(BetStatus.Rejected);
    }
    get selectionsCount() {
        return this.selections.length;
    }
    removeError(key, type) {
        if (this.errors[key] && this.errors[key][type]) {
            this.errors.remove(this.errors[key]);
        }
        return this.errors;
    }
    formatedErrors() {
        let allErrors = [];
        this.errors.forEach((error, index) => (Object.keys(error).forEach(x => {
            let formatedError = new UIMessageModel({
                id: `error-${x}`,
                label: error[x].join(" "),
                modifier: MessageModifiers.Change,
                type: UIMessageStatus.Error,
                handler: this.removeError.bind(this, index, x)
            });
            allErrors.push(formatedError);
        }, this)), this);
        return allErrors;
    }
    formatedAcceptedMessage(betAcceptedMessage, purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `accepted-${purchaseId}` : `accepted`,
            modifier: MessageModifiers.Accepted,
            label: betAcceptedMessage,
            type: UIMessageStatus.Accepted
        });
    }
    formatedOddsChangeMessage(purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `oddsChanged-${purchaseId}` : `oddsChanged`,
            modifier: MessageModifiers.Change,
            label: this.dict.OddsChanged,
            type: UIMessageStatus.Default
        });
    }
    formatedStakeChangeMessage(purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `stakeChanged-${purchaseId}` : `stakeChanged`,
            modifier: MessageModifiers.Change,
            label: this.dict.StakeChanged,
            type: UIMessageStatus.Waiting
        });
    }
    formatedTaxMessage(taxText, purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `tax-${purchaseId}` : `tax`,
            modifier: MessageModifiers.Info,
            label: taxText,
            type: UIMessageStatus.Tax
        });
    }
    formatedPurchaseMessage(text, purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `purchase-msg-${purchaseId}` : `purchase-msg`,
            modifier: MessageModifiers.Purchase,
            label: text,
            type: UIMessageStatus.Purchase
        });
    }
    formatedInfoMessage(text, purchaseId) {
        return new UIMessageModel({
            id: purchaseId ? `info-msg-${purchaseId}` : `info-msg`,
            modifier: MessageModifiers.Info,
            label: text,
            type: UIMessageStatus.Default
        });
    }
    shouldDisplayError() {
        return (this.betStatus === BetStatus.Rejected || this.betStatus === BetStatus.Default) && this.errors.length !== 0 && this.selections.length > 0;
    }
    getTax(purchaseId) {
        let currentPurchase = this.purchases.find(x => x.id === purchaseId);
        return currentPurchase && currentPurchase.tax || "";
    }
    getPurchaseMessages(purchaseId) {
        let currentMessages = [];
        let currentPurchase = this.purchases.find(x => x.id === purchaseId);
        currentPurchase && currentPurchase.messages && currentPurchase.messages.forEach((msg) => {
            msg !== "" && currentMessages.push(this.formatedPurchaseMessage(msg, purchaseId));
        }, this);
        return currentMessages;
    }
    placeBet() {
        let result = false;
        this.purchases.forEach(p => {
            if (p && p.stake) {
                result = this.provider.placeBet(p.stake, this.selections);
            }
        }, this);
        return result;
    }
    removeSelections() {
        if (this.selections.length) {
            this.provider.removeSelections(this.selections);
        }
    }
    removeSelection(selectionId) {
        let result = false;
        let selection = this.selections.find(sel => sel.id === selectionId);
        if (selection) {
            result = this.provider.removeSelections([selection]);
        }
        return result;
    }
    cancelHandler() {
        this.betStatus === BetStatus.NewOffer ? this.clearPurchases() : this.removeSelections();
    }
    retainPurchases() {
        let result = false;
        this.purchases.forEach(p => {
            if (p.id && p.viewKey) {
                result = this.provider.retainPurchase(p.id, p.viewKey);
            }
        }, this);
        return result;
    }
    clearPurchases() {
        let result = false;
        let purchases = this.purchases.filter(x => x.id !== "" && x.viewKey !== undefined);
        if (purchases.length > 0) {
            result = this.provider.clearAllPurchases(purchases);
        }
        return result;
    }
    get isBetWaitingOrAccepted() {
        return this.betStatus === BetStatus.Waiting || this.betStatus === BetStatus.Accepted;
    }
    get stakeValue() {
        return this.purchases.length && this.purchases[0].stake || "0";
    }
    get buildFreeBetSectionProps() {
        return {
            id: "yourbet-free-bet-checkbox",
            checked: this.isChecked,
            freeBets: this.freeBets,
            selectFreeBet: this.toggleSelectFreeBetHandler,
            selectedFreeBet: this.selectFreeBet,
            useFreeBetPhrase: this.dict.UseFreeBet
        };
    }
    toggleSelectFreeBetHandler(id) {
        const selectFreeBet = this.freeBets.find(fb => fb.id.toString() === id);
        if (id && selectFreeBet) {
            this.isChecked = true;
            this.selectFreeBet = selectFreeBet;
            return this.provider.selectFreeBet(id);
        }
        this.isChecked = false;
        this.selectFreeBet = this.freeBets[0];
        return this.provider.selectFreeBet("-1");
    }
    get getStake() {
        return this.purchases.length && this.purchases[0] && this.purchases[0].stake || "0";
    }
    shouldAddTax(tax) {
        return tax !== "" && this.selectionsCount > 1;
    }
    changeVisibility(shouldShow) {
        this.isShown = shouldShow;
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], YourbetMiniBetSlipData.prototype, "isShown", void 0);
__decorate([
    observable,
    __metadata("design:type", FreeBetModel)
], YourbetMiniBetSlipData.prototype, "selectFreeBet", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], YourbetMiniBetSlipData.prototype, "errors", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], YourbetMiniBetSlipData.prototype, "purchases", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], YourbetMiniBetSlipData.prototype, "bets", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], YourbetMiniBetSlipData.prototype, "selections", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], YourbetMiniBetSlipData.prototype, "freeBets", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], YourbetMiniBetSlipData.prototype, "isChecked", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], YourbetMiniBetSlipData.prototype, "betStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], YourbetMiniBetSlipData.prototype, "stakeButtonsStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], YourbetMiniBetSlipData.prototype, "isPlaceBetButtonDisabled", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "deactivate", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "isWaiting", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "isAccepted", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "changeStake", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateSelections", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateFreeBets", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "setIsBetButtonDisabled", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateErrors", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updatePurchases", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateBets", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateStakeButtonsStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateSelectedFreeBetId", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "leftComponentStake", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "leftComponentButton", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "rightComponent", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateBetStatus", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "updateBetStatusToRejected", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "selectionsCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, String]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "removeError", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "cancelHandler", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "retainPurchases", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "clearPurchases", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "isBetWaitingOrAccepted", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "stakeValue", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "buildFreeBetSectionProps", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "toggleSelectFreeBetHandler", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], YourbetMiniBetSlipData.prototype, "getStake", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], YourbetMiniBetSlipData.prototype, "changeVisibility", null);
/* tslint:enable:cyclomatic-complexity */ 
//# sourceMappingURL=YourbetMiniBetSlipData.js.map